// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1Cw4h","doubleRow":"Form_doubleRow__3PjLh","campi":"Form_campi__2tPzQ","p":"Form_p__1V7DV","submitBox":"Form_submitBox__2Kgix"};